import styled from 'styled-components';
import { LegacyListItem, List } from 'styles';

export const StyledList = styled(List)`
  border-radius: ${props => props.theme.borderRadii.large};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledLegacyListItem = styled(LegacyListItem)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};

  &:first-child {
    border-top: 1px solid ${props => props.theme.colors.background.tertiary};
  }

  div {
    display: flex;
  }

  svg {
    margin-right: 16px;
  }

  ${props => props.theme.media.small`
    div {
      display: block;
    }
  `}
`;
